// extracted by mini-css-extract-plugin
export default {"applicationNumber":"ImportantNumber_applicationNumber__gZGW7","applicationNumberColor":"ImportantNumber_applicationNumberColor__re8fY","word":"ImportantNumber_word__A0oVU"};